import { CAP, COMP_REPEATER, DIODE, IND, RLC } from '../../constants/componentType';
import { IC, CONNECTOR, RES } from '../PCBHelper';
import SchematicCanvas from './canvas';
import ElementsCanvas from './elementsCanvas';

const IC_COLOR = "#6495ed",
  CONNECTOR_COLOR = "#9998ff",
  RLC_COLOR = "#f4b183",
  CLAMP_DIODE_COLOR = "#7e7e7e",
  REPEATER_COLOR = "#b15432";
function getColor(type) {
  switch (type) {
    case IC: return IC_COLOR;
    case CONNECTOR: return CONNECTOR_COLOR;
    case RES:
    case IND:
    case CAP:
    case RLC: return RLC_COLOR;
    case DIODE: return CLAMP_DIODE_COLOR;
    case COMP_REPEATER: return REPEATER_COLOR;
    default: return;
  }
}

function getTitle(type) {

  switch (type) {
    case IC: return IC;
    case CONNECTOR: return CONNECTOR;
    case RES: return "Pull Up Resistor";
    case RLC: return RLC;
    case DIODE: return "D";
    case COMP_REPEATER: return COMP_REPEATER;
    default: return type;
  }
}

export {
  SchematicCanvas,
  ElementsCanvas,
  getColor,
  getTitle,
  CLAMP_DIODE_COLOR
}
